import { render, staticRenderFns } from "./InfoExternal.vue?vue&type=template&id=3f9e2cef&scoped=true"
import script from "./InfoExternal.vue?vue&type=script&lang=js"
export * from "./InfoExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9e2cef",
  null
  
)

export default component.exports